var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsNavegaciNHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillOpacity: 0.8,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11 .44L21.06 10.5 20 11.56l-.754-.753.001 10.943h-6.72v-6.775h-3v6.775H2.751V10.81L2 11.56.94 10.5 11 .44zm0 2.12L4.25 9.31l.001 10.94h3.776v-6.775h6v6.775h3.72V9.307L11 2.561z",
    transform: "translate(-793 -485) translate(793 485) translate(1 1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNavegaciNHome);
export default __webpack_public_path__ + "static/media/icons-navegaci-n-home.82e1ced5.svg";
export { ForwardRef as ReactComponent };